/**
 * External Dependencies
 */
import { throttle } from 'lodash'
/**
 * Internal Dependencies
 */
import { addStateClass, removeStateClass } from './utils'

export class ScrollWatcher {
  scrolled: any
  scrollThreshold: number
  lastScroll: number

  constructor ( scrollThreshold: number ) {
    this.scrollThreshold = scrollThreshold
    this.lastScroll = window.pageYOffset
    this.scrolled = this.haveWeScrolled()
    window.addEventListener('scroll',
      throttle(() => this.haveWeScrolled(), 100))
  }

  haveWeScrolled () {
    this.scrolled = window.pageYOffset > this.scrollThreshold
    if (this.scrolled) {
      addStateClass('scrolled')
    } else {
      removeStateClass('scrolled')
    }
    if (window.pageYOffset < this.lastScroll) {
      addStateClass('scrolled-up')
    } else {
      removeStateClass('scrolled-up')
    }
    this.lastScroll = window.pageYOffset
    return this.scrolled
  }
}

/**
 * Example
 let scrollWatcher = new ScrollWatcher(100)
 */